export default function popupForm () {
    const opener = document.querySelector('.popup-schedule-opener');
    const popupWrap = document.querySelector('.popup-schedule__wrap .subscribe__frame');
    const body = document.querySelector('body');

    const openPopup = () => {
        body.classList.add('popup-schedule-active');
    };

    const closePopup = (event) => {
        if (!popupWrap.contains(event.target) && !opener.contains(event.target)) {
            body.classList.remove('popup-schedule-active');
        }
    };

    opener.addEventListener('click', (event) => {
        event.preventDefault();
        openPopup();
    });

    document.addEventListener('click', closePopup);
}